'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var last = _interopDefault(require('lodash/last'));

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function fileToBase64(_x) {
  return _fileToBase.apply(this, arguments);
}

function _fileToBase() {
  _fileToBase = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(file) {
    var reader;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            reader = new FileReader();
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              reader.onerror = function () {
                reader.abort();
                reject(new DOMException('Problem parsing input file.'));
              };

              reader.onloadend = function () {
                resolve(reader.result);
              };

              reader.readAsDataURL(file);
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fileToBase.apply(this, arguments);
}

function clipString(text) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 35;
  var length = text.length;
  var first = Math.max(0, Math.floor((size - 3) / 2));
  var last = Math.max(0, Math.ceil(length - first));
  return length < size ? text : "".concat(text.slice(0, first), "...").concat(text.slice(last));
}

function isIOS() {
  return navigator && /iPad|iPhone|iPod/.test(navigator.userAgent);
}

function nl2Br(content) {
  return typeof content === 'string' ? content.replace(/(?:\r\n|\r|\n)/g, '<br />') : '';
}

function sleep(time) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, time);
  });
}

function isDev() {
  return process.env.NODE_ENV === 'development';
}

function getElByHash() {
  if (window && window.location.hash && window.location.hash.length > 1) {
    var id = last(window.location.hash.split('#'));
    return document.getElementById(id);
  }

  return null;
}

function scrollToEl(el) {
  var behavior = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'smooth';

  var scroll = function scroll() {
    var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return window.scrollTo({
      top: top,
      behavior: behavior
    });
  };

  if (el) {
    var top = el.offsetTop;
    scroll(top);
  } else {
    scroll(0);
  }
}

exports.clipString = clipString;
exports.fileToBase64 = fileToBase64;
exports.getElByHash = getElByHash;
exports.isDev = isDev;
exports.isIOS = isIOS;
exports.nl2Br = nl2Br;
exports.scrollToEl = scrollToEl;
exports.sleep = sleep;
